import styled from 'styled-components';
import * as fonts from 'view/styles/fonts';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line rulesdir/no-styled-export
export const Headline = styled.h3`
    ${fonts.h400};
    margin-top: ${token('space.300', '24px')};
    margin-bottom: ${token('space.100', '8px')};
`;
